import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextAreaField } from 'src/components/mui-overrides/Textarea';

interface Props {
  disabled?: boolean;
}

export const PropertyHighlightTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <DefaultFastTextAreaField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.generalinfo.fields.propertyhighlight.label')}
      placeholder={t('dashboard.assets.addedit.main.generalinfo.fields.propertyhighlight.placeholder')}
      fieldName="descriptions.propertyHighlight"
    />
  );
};
